import { render } from "./ZxPopbox.vue?vue&type=template&id=0a9ed8fe&scoped=true"
import script from "./ZxPopbox.vue?vue&type=script&lang=js"
export * from "./ZxPopbox.vue?vue&type=script&lang=js"

import "./ZxPopbox.vue?vue&type=style&index=0&id=0a9ed8fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9ed8fe"]])

export default __exports__